module.exports = __webpack_public_path__ + "static/media/x_red.e7cf0bb7.svg";